exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3nWz78T-I2yzoy97_hAUR_{display:block}", ""]);
// Exports
exports.locals = {
	"groupPicture": "_3nWz78T-I2yzoy97_hAUR_"
};